import { cn } from '@insta-club/utilities';
import { forwardRef } from 'react';
import LoadingIcon from 'src/libs/components/icons/loading';
import buttonStyle from './button.constants';
import ButtonProps from './button.types';

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
    (
        {
            variant = 'fill',
            size = 'md',
            color = 'primary',
            className = '',
            children,
            icon,
            iconPosition = 'start',
            loading = false,
            fullWidth = false,
            disabled = false, // اضافه شده
            ...props
        },
        ref
    ) => {
        const baseClasses = cn('cursor-pointer text-center', { 'w-full': fullWidth }, className);

        // اگر disabled یا loading باشد، فقط کلاس disabled اضافه می‌شود
        const variantClasses =
            disabled || loading
                ? buttonStyle.getVariantClasses({ variant: 'disabled', color })
                : buttonStyle.getVariantClasses({ variant, color });

        const sizeClasses = buttonStyle.size[size];
        const combinedClassName = `${baseClasses} ${variantClasses} ${sizeClasses} ${className}`.trim();

        return (
            <button ref={ref} className={combinedClassName} disabled={disabled || loading} {...props}>
                {loading ? (
                    <LoadingIcon className='h-5 w-5 animate-spin' />
                ) : (
                    <>
                        {icon && iconPosition === 'start' && (
                            <span className={`${children && icon ? 'ml-2' : ''}`}>{icon}</span>
                        )}
                        {children}
                        {icon && iconPosition === 'end' && (
                            <span className={`${children && icon ? 'mr-2' : ''}`}>{icon}</span>
                        )}
                    </>
                )}
            </button>
        );
    }
);

Button.displayName = 'Button';

export default Button;

